export const DURATION_VALUES = [
    1, 5, 10, 20, 30, 40, 50,
    60, 120, 180, 240, 300,
    600, 1200, 1800, 2400, 3000,
    3600, 7200, 10800, 14400, 18000,
    21600, 25200, 28800, 32400, 36000,
    39600, 43200, 46800, 50400, 54000,
    57600, 61200, 64800, 68400, 72000,
    75600, 79200, 82800, 86400,
];

export const DURATION_MIN_VALUE = 1;
export const DURATION_MAX_VALUE = 86400;

export interface IDurationMarker {
    position: number,
    value: number,
}

export const DURATION_MARKERS: IDurationMarker[] = [
    {position: 2, value: 1},
    {position: 10, value: 30},
    {position: 20, value: 60},
    {position: 33, value: 1800},
    {position: 42, value: 3600},
    {position: 50, value: 18000},
    {position: 62, value: 36000},
    {position: 74, value: 54000},
    {position: 90, value: 86400},
];

export function adjustLastMarker<T extends {position: number}>(markers: T[], isMini: boolean): T[] {
    const lastPosition = isMini ? 90 : 96;

    return markers.map((marker, index) =>
        index === markers.length - 1 ? {...marker, position: lastPosition} : marker,
    );
}

export function getDurationProgressPct(seconds: number): number {
    const valueIndex = DURATION_VALUES.indexOf(Number(seconds));

    if (valueIndex === -1) {
        return 0;
    }

    return (valueIndex / (DURATION_VALUES.length - 1)) * 100;
}

export function getDurationFillWidthPct(progressPct: number, seconds: number): number {
    const EXTRA_PCT = 5;

    if (seconds > 1 && seconds <= 240) {
        const extraWidth = (EXTRA_PCT * (240 - seconds)) / 239;
        return Math.min(progressPct + extraWidth, 100);
    }

    return progressPct;
}

export function getDurationByOffset(offset: number, width: number): number {
    const x = Math.max(0, Math.min(offset, width));
    const percent = (x / width) * 100;
    const index = Math.round((percent / 100) * (DURATION_VALUES.length - 1));
    const clampedIndex = Math.max(0, Math.min(index, DURATION_VALUES.length - 1));

    return DURATION_VALUES[clampedIndex];
}

export type DurationUnit = 'seconds' | 'minutes' | 'hours';

export function splitDuration(seconds: number): {unit: DurationUnit, amount: number} {
    if (seconds < 60) {
        return {unit: 'seconds', amount: seconds};
    }

    if (seconds < 3600) {
        return {unit: 'minutes', amount: Math.floor(seconds / 60)};
    }

    return {unit: 'hours', amount: Math.floor(seconds / 3600)};
}
